import React from 'react';
import dynamic from 'next/dynamic';
import { Loader } from '@/components';
import { fetchBrands } from '@fh-components/fh-js-api-core/store/slices/profileSlice';
import { MetaData } from '@/containers';
import { useSelector } from 'react-redux';
import { getBrandsSeo } from '@/store/profileSelector';

const Brands = dynamic(() => import('../../containers/brands'), {
	loading: () => <Loader />,
});

const NextBrandsPage = () => {
	const brandsSeo = useSelector(getBrandsSeo);

	return (
		<>
			<MetaData
				title={brandsSeo?.title}
				description={brandsSeo?.description}
			/>
			<Brands seoData={brandsSeo} />
		</>
	);
};

NextBrandsPage.getInitialProps = async ({ reduxStore }) => {
	await reduxStore.dispatch(fetchBrands());

	return {};
};

export default NextBrandsPage;
